import claudeOverview from '~docs/help/claude/README.md?raw';
import claudeChat from '~docs/help/claude/01-claude-chat.md?raw';
import claudeCode from '~docs/help/claude/02-claude-code.md?raw';
import claudeAccess from '~docs/help/claude/03-managing-access.md?raw';
import solidtimeOverview from '~docs/help/solidtime/README.md?raw';
import solidtimeConnect from '~docs/help/solidtime/01-connect-account.md?raw';
import solidtimeTrack from '~docs/help/solidtime/02-track-time.md?raw';

export interface HelpPage {
  /** URL segment: /help/<guide>/<page> */
  slug: string;
  /** Markdown filename in the guide directory — the target of relative links between pages */
  file: string;
  title: string;
  content: string;
}

export interface HelpGuide {
  slug: string;
  title: string;
  description: string;
  icon: string;
  pages: HelpPage[];
}

// Explicit allowlist: only user-facing guides from docs/ are published here.
// Dev documentation (ADRs, plans, specs) is intentionally left out.
export const GUIDES: HelpGuide[] = [
  {
    slug: 'claude',
    title: 'Connect DOTT to Claude',
    description:
      'Manage your requests and issues straight from Claude — set up the MCP connector for Claude chat, Desktop, and Claude Code.',
    icon: 'i-lucide-sparkles',
    pages: [
      { slug: 'overview', file: 'README.md', title: 'Overview', content: claudeOverview },
      { slug: 'claude-chat', file: '01-claude-chat.md', title: 'Claude chat & Desktop', content: claudeChat },
      { slug: 'claude-code', file: '02-claude-code.md', title: 'Claude Code', content: claudeCode },
      { slug: 'managing-access', file: '03-managing-access.md', title: 'Managing access', content: claudeAccess },
    ],
  },
  {
    slug: 'solidtime',
    title: 'Track time with solidtime',
    description:
      'Start a timer for the issue you\'re working on right from DOTT — connect your solidtime account once, then track time in one click.',
    icon: 'i-lucide-timer',
    pages: [
      { slug: 'overview', file: 'README.md', title: 'Overview', content: solidtimeOverview },
      { slug: 'connect-account', file: '01-connect-account.md', title: 'Connect your account', content: solidtimeConnect },
      { slug: 'track-time', file: '02-track-time.md', title: 'Track time on issues', content: solidtimeTrack },
    ],
  },
];

export const findGuide = (guideSlug: string): HelpGuide | undefined =>
  GUIDES.find((guide) => guide.slug === guideSlug);

export const findPage = (guide: HelpGuide, pageSlug: string): HelpPage | undefined =>
  guide.pages.find((page) => page.slug === pageSlug);

/** Resolves a relative `.md` link from page content to a page in the same guide. */
export const findPageByFile = (guide: HelpGuide, file: string): HelpPage | undefined =>
  guide.pages.find((page) => page.file === file);
